export default "__VITE_ASSET__OmByeEIt__"